if(!window.routes){
  window.routes = {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    predictive_search_url: '/search/suggest',
  };
}
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super(); 

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        $('#satcb_quantity').remove();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var cart_add_url = routes.cart_add_url;
        var formData = new FormData(this.form),
            $this = this;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          config.body = formData;
        }
        // formData.append('quantity', $(this.form).parents('product-info').find('.quantity__input').val());
        if(this.submitButton.classList.contains("bundle-atc-btn") == true){
          var $this_form = this.form;
          // console.log(this.form);
          // console.log($this_form.find('.bundle-variants select').length);
          var $this_form = this.form,
              formData = { 'items': [] },
              $List = [],
              $qty = $('.product__info-container .quantity__input').val(),
              custombundleof = $('.custom-bundle-of').val(),
              custombundleofhandle = $('.custom-bundle-of-handle').val(),
              bundlepidlist = $('.bundle-pid-list').val(),
              bundle_select = $($this_form).parents('product-info').find('.bundle-variants select');
          formData.sections_url = window.location.pathname;
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          this.cart.setActiveElement(document.activeElement);
          bundle_select.each(function(){
            if(jQuery.inArray($(this).val(),$List) == -1){
              $List.push($(this).val());
            }
          });
          for(i=0; i < $List.length; i++){
              var $bundleqty = 0;
              bundle_select.each(function(){
                if($List[i] == $(this).val()){
                  $bundleqty++;
                }
              });
              $bundleqty = $bundleqty*$qty;
            formData.items.push({ 'id': $List[i],'quantity': $bundleqty, properties:{'_custom-bundle-of':custombundleof, '_bundle-pid-list':bundlepidlist, '_custom-bundle-of-handle':custombundleofhandle} })
          }
          config.body = JSON.stringify(formData);
          config.headers['Content-Type'] = "application/json";
          var cart_add_url = `${routes.cart_add_url}.js`;
        }
        fetch(cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if(this.submitButton.classList.contains("bundle-atc-btn") == true){
              if($('.custom-bundle-of-handle').val()){
                console.log("$bundleqty",$bundleqty);
                GA4.bundle_add_to_cart($('.custom-bundle-of-handle').val(),$bundleqty);
              }
            }else{
              GA4.add_to_cart(response);
            }
            if (!this.error)
              if(this.submitButton.classList.contains("bundle-atc-btn") == false){
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;
  return [day, month, year].join('/');
}

function calculateEstimatedDelivery() {
  var cutOffTime = 12;
  var aestTime = new Date().toLocaleString("en-US", {timeZone: "Australia/Sydney"});
  var currentDate = new Date(aestTime);
  var currentHour = currentDate.getHours();
  var HolidayList = ["26/12/2024","01/01/2025","21/04/2025"];
  //DD/MM/YYYY

  if(currentHour > cutOffTime - 1){
    currentDate.setDate(currentDate.getDate() + 1);
  }
  var dispatchDate = new Date(currentDate);
  var currentDay = currentDate.getDay();

  if(currentDay > 0 && currentDay < 6){
    dispatchDate = new Date(currentDate);
  }else if(currentDay == 6){
    dispatchDate.setDate(dispatchDate.getDate() + 2);
  }else if(currentDay == 0){
    dispatchDate.setDate(dispatchDate.getDate() + 1);
  }

  var dispatchDay = dispatchDate.getDay();
  var deliveryDate = new Date(dispatchDate);
  deliveryDate.setDate(dispatchDate.getDate() + 2);

  if(dispatchDay == 4){
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  } else if(dispatchDay == 5){
    deliveryDate.setDate(deliveryDate.getDate() + 2);
  }

  for(i=0; i < HolidayList.length; i++){
    var holiday = HolidayList[i];
    var dateFrom = formatDate(dispatchDate);
    var dateTo = formatDate(deliveryDate);
    
    var d1 = dateFrom.split("/");
    var d2 = dateTo.split("/");
    var c = holiday.split("/");
    
    var from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
    var to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
    var check = new Date(c[2], parseInt(c[1])-1, c[0]);
    
    if(check >= from && check <= to){
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    var deliveryDay = deliveryDate.getDay();
    if(deliveryDay == 6){
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    }else if(deliveryDay == 0){
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
  }
  var month = deliveryDate.toLocaleString('default', { month: 'short' });

  var nthNumber = (number) => {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };
  
  var date = `${deliveryDate.getDate()}${nthNumber(deliveryDate.getDate())} ${month}`;
  return date;
}

if(document.getElementById('delivery-date')){
   // document.getElementById('delivery-date').innerHTML = calculateEstimatedDelivery();
   // document.getElementsByClassName('expected-delivery')[0].style.display='block';
  $('#delivery-date').html(calculateEstimatedDelivery());
  $('.expected-delivery').css('display','flex');
}

window.Shopify.uniq = function(t) {
  for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
  return e
}
Shopify.arrayIncludes = function(t, e) {
  for (var o = 0; o < t.length; o++)
      if (t[o] == e) return !0;
  return !1
}

window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .product-form__input .select__select:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .product-form__input .select__select:eq(0)`).val();
      key += ` / ${$(`${parent} .product-form__input .select__select:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  var selector = jQuery(parent + ' .product-form__input .select__select:eq(' + selectorIndex + ')');
  var initialValue = selector.val();
  
  if($(".variant-v2").length == 0){
    selector.empty();
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = jQuery("<option></option>").val(option).html(option);
      selector.append(newOption);
    }
    if (jQuery.inArray(initialValue, availableOptions) !== -1) {
      selector.val(initialValue);
    }
    selector.change();
  }
};

window.Shopify.updateOptionsInSelectorRadio = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} fieldset:eq(0) input:checked`).val();
      break;
    case 2:
      var key = $(`${parent} fieldset:eq(0) input:checked`).val();
      key += ` / ${$(`${parent} fieldset:eq(1) input:checked`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  var selector = jQuery(parent + ' fieldset:eq('+selectorIndex+')');
  var $product = window.productJSONData;
  var initialValue = selector.val();
    selector.find("label").removeClass("v-available");
    selector.find("label").addClass("v-unavailable");
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      // console.log(option,selector.find("input[value='"+option+"']+lable").length);
      selector.find(`input[value="${option}"]+label`).addClass("v-available");
      selector.find(`input[value="${option}"]+label`).removeClass("v-unavailable");
      if(selectorIndex == 1){
        for(j=0; j< $product.variants.length; j++){
          $variant = $product.variants[j];
          if($variant.option1 == key && $variant.option2 == option){
            if($variant.featured_image){
              var $img = $variant.featured_image.src+'&width=200';
            }else{
              var $img = $product.featured_image+'&width=200';
            }
              selector.find(`input[value="${option}"]+label .swatch-flavour-img`).empty().html(`<img src="${$img}">`) 
          }
        }
      }
    }
    if(selector.find("input:checked+label.v-available").length == 0){
      selector.find(".v-available").first().click();
    }
    $('.variant-v2 variant-radios .product-form__input').each(function(){
      var $length = $(this).find('.v2-swatch-wrapper .v-available').length;
      $(this).find('.option-size').html($length+' options');
    });
};

window.Shopify.changeorder = function(options){
  if(window.pre_order_options){
    const moveToBottom = window.pre_order_options.split(',');
    const isTargetOption = (option) =>  moveToBottom.some(target => option.toLowerCase().includes(target.toLowerCase()));
    
    const bottomOptions = options.filter(isTargetOption);
    const otherOptions = options.filter(option => !isTargetOption(option));
    
    const reorderedOptions = [...otherOptions, ...bottomOptions];
    return reorderedOptions;
  }else{
    return options;
  }
}

window.Shopify.linkOptionSelectors = function (product, parent) {
  // console.log('INININININI')
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      window.Shopify.optionsMap.root = window.Shopify.changeorder(window.Shopify.optionsMap.root)
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
        window.Shopify.optionsMap[key] = window.Shopify.changeorder(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
        window.Shopify.optionsMap[key] = window.Shopify.changeorder(window.Shopify.optionsMap[key]);
      }
    }
  }
  
  // When there is an update in the first dropdown.
  if($(".variant-v2").length){
    window.Shopify.updateOptionsInSelectorRadio(0, parent);
    if (product.options.length > 1) window.Shopify.updateOptionsInSelectorRadio(1, parent);
    $(`${parent} fieldset:eq(0) input[type=radio]`).change(() => {
      if (product.options.length === 2)window.Shopify.updateOptionsInSelectorRadio(1, parent);
      return true;
    });
  }else{
    // Update options right away.
    window.Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    
    $(`${parent} .product-form__input .select__select:eq(0)`).change(() => {
      if (product.options.length === 2)window.Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(`${parent} .product-form__input .select__select:eq(1)`).change(() => {
      if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
  }
  // console.log("parent",parent);
  // if(window.trigger_first_option){
  //   const parentElement = document.querySelector(parent);
  //   if(parentElement){
  //     const selectElement = parentElement.querySelectorAll('.product-form__input .select__select')[1];
  //     if (selectElement) {
  //       const firstOptionValue = selectElement.querySelector('option')?.value;
  //       if (firstOptionValue) {
  //         selectElement.value = firstOptionValue;
  //         const event = new Event('change', { bubbles: true });
  //         selectElement.dispatchEvent(event);
  //       }
  //     } 
  //   }else{
  //     $(`${parent} .product-form__input .select__select:eq(1)`).val($(`${parent} .product-form__input .select__select:eq(1) option:first`).val()).change();
  //   }
  // }
};

$('.product__info-wrapper-last-column').each(function(){
  var $this = $(this);
  if($this.find('.product__info-container').data('handle')){
    setTimeout(function(){
      var Handle = $this.find('.product__info-container').data('handle');
      var JSONData = JSON.parse(document.getElementById("product-" + Handle).innerHTML);
      window.productJSONData = JSONData;
      var $id = $('.product__info-wrapper-last-column .product__info-container[data-handle='+Handle+'] variant-selects').attr('id');
      if($(".variant-v2").length){
        Shopify.linkOptionSelectors(JSONData, '.product__info-wrapper-last-column .product__info-container[data-handle='+Handle+'] variant-radios');
      }else{
        if($id){
          Shopify.linkOptionSelectors(JSONData, '#'+$id);
        }else{
          Shopify.linkOptionSelectors(JSONData, '.product__info-wrapper-last-column .product__info-container[data-handle='+Handle+'] variant-selects');
        }
      }
    },1000);
  }
});

if(window.PurpleDotConfig) {
    function pd_widget(){
        // var $myDiv = $('#pd-learn-more-bundle');
        // var originalText = $myDiv.html();
        // var modifiedText = originalText.replace("shopify-app.waitlist-protected-by", "Pre-order protected by");
        // var modifiedText2 = modifiedText.replace("shopify-app.learn-more", "Learn more");
        // $myDiv.html(modifiedText2);

        // const $selector = document.getElementById("pd-learn-more-bundle")
        // const originalText = $selector.innerHTML;
        // const modifieldText = originalText.replace("shopify-app.waitlist-protected-by", "Pre-order protected by").replace("shopify-app.learn-more", "Learn more");
        // $selector.innerHTML = modifieldText;

      if($('#pd-learn-more-bundle #pd-branding .protected_by').length == 0){
        $('#pd-learn-more-bundle #pd-branding').prepend('<span class="protected_by">Pre-order protected by</span>')
        $('#pd-learn-more-bundle #pd-branding span:not(.pd-logo,.protected_by)').html('Learn more')
      }
      
        var $pre_order = false;
        $(".pd-bundle-message").each(function() {
            if($(this).text().length){
              $pre_order = true;
            }
        });
        if($pre_order){
          $("#pd-learn-more-bundle").show();
          $('.expected-delivery').hide();
          $(".product__availability").html('Availability online: <span class="out_of_stock">Out Of Stock (Available for Pre-order)</span>');
          $(".product-form__submit span").html("PRE-ORDER");
        }else{
          $("#pd-learn-more-bundle").hide();
          $('.expected-delivery').show();
          if($(".product-form__submit").attr('bundle_availability') == "false"){
            $(".product__availability").html('Availability online: <span class="out_of_stock">Out of stock</span>');
            $(".product-form__submit span").html("SOLD OUT"); 
          }else{
            $(".product__availability").html('Availability online: <span class="in__stock">In stock</span>');
            $(".product-form__submit span").html("ADD TO CART"); 
          }
        }
    };
  
    $(document).on("change", ".bundle-variants select", function(){
        var $variant = $(this).val(),
            $handle = $(this).data("handle"),
            $pd_url = `https://www.purpledotprice.com/api/v1/variants/preorder-state?api_key=${window.PurpleDotConfig.apikey}&variant_id=${$variant}`;
        if($variant){
          fetch($pd_url).then(res => res.json()).then(response => {
              var $handle2 = response.data.product.handle;
              response.data.state == "ON_PREORDER" ? $(`.pd-bundle-message[data-handle=${$handle2}]`).html(`(${response.data.waitlist.display_dispatch_date})`) : $(`.pd-bundle-message[data-handle=${$handle2}]`).empty(),
              pd_widget();
          });
        }
    });
    $(".bundle-variants select").change();
}

$('.quantity-pack input[type=radio]').change(function(){
 $('.quantity-pack').removeClass("active");
 $(this).parent().addClass("active");
});

var wrapper_v3 = document.querySelector('.flavour-type-variant-wrapper .v2-swatch-wrapper');    
if(wrapper_v3){
  const children = Array.from(wrapper_v3.children);
  const pairs = [];
  
  for (let i = 0; i < children.length; i += 2) {
    const input = children[i];
    const label = children[i + 1];
    if (input && label && label.tagName === 'LABEL') {
      const text = label.textContent.trim().toLowerCase();
      pairs.push({ input, label, text });
    }
  }
  
  pairs.sort((a, b) => a.text.localeCompare(b.text));
  
  wrapper_v3.innerHTML = '';
  pairs.forEach(pair => {
    wrapper_v3.appendChild(pair.input);
    wrapper_v3.appendChild(pair.label);
  });
}